import { GET_PAYMENT_GATEWAYS, GET_PAYMENT_GATEWAYS_SUCCESS, GET_PAYMENT_GATEWAYS_ERROR, GET_PAYMENT_GATEWAYS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetPaymentGateways = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_GATEWAYS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PAYMENT_GATEWAYS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PAYMENT_GATEWAYS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PAYMENT_GATEWAYS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetPaymentGateways;
